// import React from 'react';
// import FormSide from '../../components/services-details/FormSide';
// import FssaiLicenceDocuments from '../../components/services-details/FssaiLicenceDocuments';
// import TypesWithFoodBusiness from '../../components/services-details/TypesWithFoodBusiness';
// import { useParams } from 'react-router-dom';
// import services from "../../services.json";

// const ServicesDetails = () => {
//     const params = useParams();

//     const getServiceDataById = (id) => {
//         const findService = (service) => {
//             if (service?.id === id) {
//                 return service;
//             }
//             if (service?.options?.length) {
//                 const serviceInsideOption = service?.options?.find(option => option?.id === id);
//                 let logo_url = service?.logo_url;
//                 if (serviceInsideOption && logo_url) {
//                     serviceInsideOption.logo_url = logo_url
//                 }
//                 return serviceInsideOption;
//             }
//             return null;
//         };

//         if (!services?.servicesData) {
//             return null;
//         }

//         for (let service of services?.servicesData) {
//             const data = findService(service);
//             if (data) {
//                 return data;
//             }
//         }

//         return null;
//     }

//     const filteredServiceData = getServiceDataById(params?.id);
//     // console.log("filteredServiceData", filteredServiceData)

//     return (
//         <React.Fragment>
//             <div className="px-10 mb-10 flex flex-col lg:flex-row p-6 space-y-6 lg:space-y-0 lg:space-x-6">
//                 <div className="lg:w-2/3 w-full rounded-md">
//                     <FssaiLicenceDocuments
//                         service={filteredServiceData}
//                     />
//                     <TypesWithFoodBusiness
//                         service={filteredServiceData}
//                     />
//                 </div>

//                 <FormSide service={filteredServiceData} />
//             </div>
//         </React.Fragment>
//     )
// }

// export default ServicesDetails;

import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import FormSide from "../../components/services-details/FormSide";
import AOS from "aos";
import "aos/dist/aos.css";


const ServicesDetails = () => {
  const { id } = useParams();
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const sectionRefs = useRef([]);
  const tabsContainerRef = useRef(null);
 useEffect(() => {
  AOS.init({ duration: 1000 });
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
}, []);

  useEffect(() => {
    const fetchService = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/services/get-service-by-id/${id}`
        );
        setServiceData(res.data);
      } catch (error) {
        console.error("Error fetching service:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchService();
  }, [id]);

  useEffect(() => {
    if (!serviceData?.overview?.length) return;

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = sectionRefs.current.findIndex(
            (ref) => ref === entry.target
          );
          if (index !== -1) {
            setActiveTab(index);

            const tabElement = document.getElementById(`tab-${index}`);
            if (tabElement && tabsContainerRef.current) {
              const container = tabsContainerRef.current;
              const tabRect = tabElement.getBoundingClientRect();
              const containerRect = container.getBoundingClientRect();

              if (tabRect.left < containerRect.left || tabRect.right > containerRect.right) {
                tabElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
              }
            }
          }
        }
      });
    }, options);

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, [serviceData]);

  const scrollToSection = (index) => {
    if (sectionRefs.current[index]) {
      sectionRefs.current[index].scrollIntoView({ behavior: "smooth" });
      setActiveTab(index);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-xl">Loading service details...</div>
      </div>
    );
  }

  if (!serviceData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-2">
            Service Not Found
          </h2>
          <p className="text-gray-600">
            The requested service could not be loaded.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <div className="container mx-auto p-4 md:px-10 md:py-10 bg-gradient-to-br from-sky-50 to-sky-100">
        <div className="flex flex-col lg:flex-row gap-10">
          {/* LEFT: Main Content */}
          <div className="w-full lg:w-2/3 space-y-6" data-aos="fade-up">
            <div className="py-2">
              <h1 className="text-2xl md:text-4xl font-bold text-gray-800 mb-4">
                {serviceData.title || serviceData.serviceName}
              </h1>

              <div className="mb-2">
                {serviceData.description?.length > 0 && (
                  <div className="mb-2 space-y-3 ">
                    {serviceData.description.map((desc, i) => (
                      <div
                        key={i}
                        className="prose prose-lg text-gray-700 text-base md:text-lg leading-relaxed font-medium text-justify"
                        dangerouslySetInnerHTML={{ __html: desc }}
                      />
                    ))}
                  </div>
                )}
              </div>

              {/* Service Images */}
              {serviceData.images && serviceData.images.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-2">
                  {serviceData.images.map((img, i) => (
                    <div key={i} className="overflow-hidden">
                      <img
                        src={img}
                        alt={`${serviceData.serviceName} ${i + 1}`}
                        className="w-full h-64 object-cover"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="w-full lg:w-1/3 ">
            <div className="sticky top-32">
              <FormSide />
            </div>
          </div>
        </div>
      </div>

      {/* Overview Section*/}
      {serviceData.overview && serviceData.overview.length > 0 && (
        <div className="w-full shadow py-10 px-4 md:px-10 ">

          <div
            ref={tabsContainerRef}
            className="sticky top-16 md:top-[4.8rem] lg:top-[2.5rem] z-20 flex overflow-x-auto bg-orange-100 scrollbar-hide rounded-md shadow-xl"
          >
            {serviceData.overview.map((item, index) => (
              <button
                id={`tab-${index}`}
                key={index}
                onClick={() => scrollToSection(index)}
                className={`flex-shrink-0 px-4 py-3  text-lg font-semibold transition-all duration-200 text-center min-w-max shadow-lg ${activeTab === index
                  ? "bg-orange-500 text-white shadow-inner rounded-md"
                  : "text-gray-700 hover:bg-orange-200"
                  }`}
              >
                {item.name}
              </button>
            ))}
          </div>

          {/* Tab Content Sections */}
          <div className="container mx-auto">
            {serviceData.overview.map((item, index) => (
              <section
                key={index}
                ref={(el) => (sectionRefs.current[index] = el)}
                className="py-12 scroll-mt-24 "
              >
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                  {/* Text Column */}
                  <div>
                    {item.title && (
                      <h3 className="md:text-3xl font-bold text-gray-800 mb-4">
                        {item.title}
                      </h3>
                    )}

                    {item.description?.length > 0 && (
                      <div className="space-y-3">
                        {item.description.map((desc, i) => (
                          <div
                            key={i}
                            className="space-y-3 text-lg text-gray-700 leading-relaxed text-justify"
                            dangerouslySetInnerHTML={{ __html: desc }}
                          />
                        ))}
                      </div>
                    )}


                    {item.points?.length > 0 && (
                      <ul className="space-y-2 text-gray-700 mt-4">
                        {item.points.map((point, i) => (
                          <li key={i} className="text-lg md:text-xl">
                            <span className="font-semibold text-xl md:text-2xl">
                              {point.heading}:
                            </span>{" "}
                            <span
                              dangerouslySetInnerHTML={{ __html: point.description }}
                            />
                          </li>
                        ))}
                      </ul>
                    )}

                  </div>

                  {/* Image Column */}
                  {item.images?.length > 0 && (
                    <div className="flex justify-center">
                      <img
                        src={item.images[0]}
                        alt={item.name}
                        className="w-full object-cover"
                      />
                    </div>
                  )}
                </div>
              </section>
            ))}
          </div>
        </div>
      )}
      {/* Author Section */}
      {(serviceData.authorName || serviceData.authorDescription) && (
        <div className="container mx-auto px-6 md:px-20 py-8">
          <div className="bg-[#dce2e5] border rounded-lg shadow-sm p-6 flex gap-4 items-start">
            {/* Author Logo */}
            {/* {serviceData.logo && (
              <img
                src={serviceData.logo}
                alt={serviceData.authorName || "Author Logo"}
                className="w-16 h-16 rounded-full object-cover border flex items-center"
              />
            )} */}

            {/* Author Info */}
            <div>
              <h2 className="text-xl md:text-2xl font-semibold mb-2">Authors</h2>
              {serviceData.authorName && (
                <p className="text-gray-700 text-[18px] mb-2">
                  Written by{" "}
                  <span className="text-blue-600 font-medium">
                    {serviceData.authorName}
                  </span>
                  . Last updated on{" "}
                  {new Date(serviceData.updatedAt).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}{" "}
                  {new Date(serviceData.updatedAt).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </p>
              )}
              {serviceData.authorDescription && (
                <div
                  className="text-gray-600 leading-relaxed text-lg md:text-xl text-justify"
                  dangerouslySetInnerHTML={{ __html: serviceData.authorDescription }}
                />
              )}

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ServicesDetails;
